import SpinStartState from "../../core/src/states/SpinStartState";
import BetModel from "../../core/src/model/BetModel";
import SpinModel from "../../core/src/model/SpinModel";
import UIController from "../../core/src/ui/UIController";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import App from "../../core/src/App";
import VendorModel from "../model/VendorModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ReelGroup from "../../core/src/views/ReelGroup";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import JackpotsModel from "../model/JackpotsModel";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import ScatterModel from "../../../game/src/models/ScatterModel";
export default class VendorSpinStartState extends SpinStartState {
    protected _canExit: boolean;

    startSpin() {
        this._canExit = false;

        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.disableSwipeSpin();

        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.DECREMENT_AUTOPLAY);
        }

        super.startSpin();
    }

    sendRequest() {
        BetModel.betTime = Date.now();
        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins() && !SpinModel.leftoverCascades) {
            if (JackpotsModel.jackpotsAvailable && JackpotsModel.playForJackpot) {
                BetModel.subtractBet(BetModel.totalBet + JackpotsModel.jackpotFee);
            } else {
                BetModel.subtractBet(BetModel.totalBet);
            }
            UIController.updateFields(UIUpdateEvent.Balance);
            SpinModel.spinFinished = false;
            App.timeline.call(
                () =>
                    CommManager.send(
                        RequestRegister.get("playRequest"),
                        this.onOpenPlay,
                        this
                    ),
                [],
                this,
                App.timeline.time + 0.5
            );
        } else {
            // TODO SAVE FS PROGRESS
            // CommManager.send(
            //     RequestRegister.get("saveState"),
            //     ()=>{this.exit();},
            //     this
            // );
            this.exit();
        }
    }

    protected onOpenPlay(data?: any) {

        ErrorModel.update(data);
        VendorModel.update(data);
        CommManager.send(
            RequestRegister.get("placeBet"),
            this.onBetCompleted,
            this
        );
    }

    protected onBetCompleted(data?: any) {
        this._canExit = true;
        ErrorModel.update(data);
        VendorModel.update(data);
        BetModel.update(data);
        CommandManager.execute(Commands.UPDATE_BALANCE);
        this.exit();
    }

    public canExit(): boolean {
        return this._canExit;
    }

}
